import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface ICreateTemplatePayload extends ISagaCb {
    data: any
    sagaCB?: {
        onSuccess: any
        onError?: any
    }
}

export interface ICreateTemplateState {
    status: string
    data: any
    errors: any
}

const initialState: ICreateTemplateState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createTemplate = createSlice({
    name: 'template/create',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateTemplatePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createTemplateActions = createTemplate.actions
export default createTemplate.reducer
